/**
 * A field no agent has written yet.
 *
 * The hatched block is not decoration — it is the point of the page. A reviewer
 * has to be able to tell "this gap has no ROI analysis" from "this gap's ROI is
 * unremarkable", so an unwritten field is drawn as a hole that names what is
 * missing and, where one exists, the agent that owes it. `roiImpact` has no
 * owner at all today, and saying so is more useful than leaving the section
 * blank.
 */
export function Placeholder({ text, owner }: { text: string; owner?: string }) {
  return (
    <div className="gr-hole gr-hatch" data-owned={Boolean(owner)}>
      <span className="gr-hole-text">{text}</span>
      <span className="gr-hole-owner">{owner ?? 'no agent owns this yet'}</span>
    </div>
  );
}
